import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Avatar,
  IconButton,
  Grid,
  Paper,
  Divider,
  Container,
} from "@mui/material";
import PhotoCamera from "@mui/icons-material/PhotoCamera";

const EditProfile = () => {
  const [profileData, setProfileData] = useState({
    firstName: "United",
    lastName: "Energy",
    email: "uep.pk@example.com",
    password: "",
    confirmPassword: "",
  });

  const [profilePicture, setProfilePicture] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfileData({ ...profileData, [name]: value });
  };

  const handleProfilePictureChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setProfilePicture(URL.createObjectURL(e.target.files[0]));
    }
  };

  const handleSubmit = () => {
    alert("Profile updated successfully!");
  };

  return (
    <Container maxWidth="sm" sx={{ py: 4 }}>
      <Paper
        elevation={0}
        sx={{
          p: 3,
          border: "1px solid #e2e8f0",
          borderRadius: 3,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 700, color: "#0b1e3d", mb: 0.5 }}>
          Edit Profile
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2.5 }}>
          Update your personal information
        </Typography>

        <Divider sx={{ mb: 3 }} />

        {/* Avatar */}
        <Box sx={{ textAlign: "center", mb: 3 }}>
          <Box sx={{ position: "relative", display: "inline-block" }}>
            <Avatar
              src={profilePicture}
              sx={{
                width: 80,
                height: 80,
                background: "linear-gradient(135deg, #1a4a8a, #60a5fa)",
                fontSize: "1.5rem",
                fontWeight: 700,
                boxShadow: "0 4px 12px rgba(13,43,94,0.25)",
              }}
            >
              {profileData.firstName?.[0]}{profileData.lastName?.[0]}
            </Avatar>
            <IconButton
              component="label"
              size="small"
              sx={{
                position: "absolute",
                bottom: -4,
                right: -4,
                background: "#0d2b5e",
                color: "#fff",
                width: 26,
                height: 26,
                "&:hover": { background: "#1a4a8a" },
              }}
            >
              <input hidden accept="image/*" type="file" onChange={handleProfilePictureChange} />
              <PhotoCamera sx={{ fontSize: 14 }} />
            </IconButton>
          </Box>
        </Box>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="First Name"
              name="firstName"
              value={profileData.firstName}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Last Name"
              name="lastName"
              value={profileData.lastName}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Email"
              name="email"
              value={profileData.email}
              onChange={handleChange}
              type="email"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="New Password"
              name="password"
              value={profileData.password}
              onChange={handleChange}
              type="password"
              placeholder="Leave blank to keep current"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Confirm Password"
              name="confirmPassword"
              value={profileData.confirmPassword}
              onChange={handleChange}
              type="password"
              placeholder="Re-enter new password"
            />
          </Grid>
        </Grid>

        <Button
          variant="contained"
          fullWidth
          sx={{ mt: 3, py: 1.1, fontWeight: 600 }}
          onClick={handleSubmit}
        >
          Save Changes
        </Button>
      </Paper>
    </Container>
  );
};

export default EditProfile;
